module.exports = __webpack_public_path__ + "static/media/map.92331c1a.png";